import styles from "../../components/Block/Block.module.scss";
import {Button, Block, Link} from "../../components";
import {useState} from "react";
import cn from "classnames";

export const ThirdBlock = ({handler, onChange, answerValue, currentAnswer}) => {
    const [success, setStep] = useState(false);
    const buttonText = success ? "Ввести ответ" : "Ввести ответ",
        buttonType = !success ? 'disabled' : 'active';

    const error = () => {
        setStep(false);
        document.querySelector('.input-answer').classList.add('error');
    }

    return (
        <Block name="box-blue-12" title="А вот и финишная прямая! Пора тренировать ушки!">
            <div className={cn(styles.desc, styles.someDesc)}><Link text={"Перейди в ЗВУК"} link={process.env.REACT_APP_PARTNER_URL}/>, подключи подписку СберПрайм, включи трек BIICLA на 43:27. Услышал? Впиши это слово в поле:</div>
            <div className={styles.form}>
                <div className={cn(styles.wrap, "input-answer")}>
                    <input onChange={(e) => {onChange(e.target.value, "answer", setStep)}} value={answerValue} type="text" placeholder="слово" className={styles.input}/>
                    {answerValue !== '' ? <div onClick={() => onChange("", "answer", setStep)} className={styles.cross}/> : ''}
                </div>
            </div>
            <Button text={buttonText} handler={currentAnswer.toUpperCase() === answerValue.toUpperCase() ? handler : error} type={buttonType} />
        </Block>
    )
}